import axios from 'axios';
// import { apiLog, console.log, warn, err } from '@/logs';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1';

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Флаг для предотвращения множественных редиректов
let isRedirecting = false;

// Отладочный интерцептор для запросов с логированием
axiosInstance.interceptors.request.use(
  (config) => {
    // Сохраняем время начала запроса для измерения длительности
    config.metadata = {
      startTime: Date.now(),
      ...config.metadata
    };

    // Логирование в нашу систему
    console.log('Axios', `➡️ Запрос: ${config.method?.toUpperCase()} ${config.url}`);

    // Логируем данные запроса если они есть (без чувствительных данных)
    if (config.data) {
      console.log('Axios', '📤 Данные запроса:', config.data);
    }

    return config;
  },
  (error) => {
    console.error('Axios', '❌ Ошибка при формировании запроса', error);
    return Promise.reject(error);
  }
);

// ЕДИНСТВЕННЫЙ интерцептор для ответов с логированием
axiosInstance.interceptors.response.use(
  (response) => {
    const duration = Date.now() - (response.config.metadata?.startTime || Date.now());

    // Логирование успешного ответа
    // apiLog(
    //   'Axios',
    //   response.config.method?.toUpperCase(),
    //   response.config.url,
    //   response.config.data,
    //   response.data,
    //   response.status,
    //   duration
    // );

    // Логируем данные ответа
    if (response.data) {
      console.log('Axios', '📥 Данные ответа:', response.data);
    }

    return response;
  },
  (error) => {
    const originalRequest = error.config;
    const duration = originalRequest?.metadata?.startTime
      ? Date.now() - originalRequest.metadata.startTime
      : null;

    // Логирование ошибки
    const errorDetails = {
      url: originalRequest?.url,
      method: originalRequest?.method?.toUpperCase(),
      status: error.response?.status,
      statusText: error.response?.statusText,
      message: error.message,
      isNetworkError: !error.response,
      duration: duration ? `${duration}ms` : 'N/A'
    };

    console.error('Axios', '❌ Ошибка ответа', {
      ...errorDetails,
      originalError: error
    });

    // Если это запрос на refresh - не обрабатываем
    if (originalRequest?.url?.includes('/auth/me')) {
      console.warn('Axios', '🔄 Запрос обновления токена не удался');
      return false;
    }

    // При любой 401 ошибке - редирект на логин
    if (error.response?.status === 401) {
      console.warn('Axios', '🔐 401 Unauthorized - требуется авторизация', {
        path: window.location.pathname,
        isRedirecting
      });

      // Проверяем, не на странице логина ли мы уже
      if (window.location.pathname.includes('/login')) {
        console.warn('Axios', 'Уже на странице логина, пропускаем редирект');
        return Promise.reject(error);
      }

      // Предотвращаем множественные редиректы
      if (!isRedirecting) {
        isRedirecting = true;

        console.warn('Axios', 'Перенаправление на страницу логина', {
          currentPath: window.location.pathname,
          redirectTo: '/login'
        });

        // Логируем очистку данных
        console.log('Axios', '🗑️ Очищены данные аутентификации из localStorage');

        // Редирект
        window.location.href = '/login';

        // Сбрасываем флаг через секунду
        setTimeout(() => {
          isRedirecting = false;
          console.log('Axios', '🔄 Флаг isRedirecting сброшен');
        }, 1000);
      } else {
        console.log('Axios', 'Редирект уже выполняется, пропускаем дублирование');
      }
    }

    // Логируем другие ошибки
    if (error.response?.status >= 500) {
      console.error('Axios', '🚨 Ошибка сервера', {
        status: error.response.status,
        url: originalRequest?.url,
        message: error.response.data?.message || error.message
      });
    } else if (error.response?.status >= 400) {
      console.warn('Axios', '⚠️ Ошибка клиента', {
        status: error.response.status,
        url: originalRequest?.url,
        message: error.response.data?.message || error.message
      });
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;